import React, { useEffect, useState } from "react";
import { showErrorToast } from "../../assets/toastUtils";
import "./FilterSection.css";
import CustomRangeSlider from "../CustomComponentsRev/CustomRangeSlider/CustomRangeSlider";

function FilterActivities({ sendDataToParent, showDestinations }) {
  const handleReset = () => {
    setDestinationArray([]);
    setSelectedBudget("");
    setDurationArray([]);
    setMinMax({ min: "", max: "" });
    setNoOfNights(0);
  };

  const [isOpenBudget, setIsOpenBudget] = useState(true);
  const [isOpenCategory, setIsOpenCategory] = useState(true);
  const [isOpenDestination, setIsOpenDestination] = useState(true);
  const [isOpenThemes, setIsOpenThemes] = useState(true);
  const [noOfNights, setNoOfNights] = useState("");
  const [isOpenDuration, setIsOpenDuration] = useState(true);
  const [themesArray, setThemesArray] = useState([]);
  const [selectedThemesArray, setSelectedThemesArray] = useState([]);

  const fetchThemesDetails = (token) => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/website/themes/list`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        // console.log(data, 'themes');
        if (data.success) {
          setThemesArray(data?.themes);
        } else {
          // console.log("Error fetching data");////////////////////////////
        }
      })
      .catch((error) => {
        console.error("Error fetching  details:", error);
      });
  };

  useEffect(() => {
    fetchThemesDetails();
  }, []);

  const toggleAccordionBudget = () => {
    setIsOpenBudget(!isOpenBudget);
  };
  const toggleAccordionCategory = () => {
    setIsOpenCategory(!isOpenCategory);
  };
  const toggleAccordionDestination = () => {
    setIsOpenDestination(!isOpenDestination);
  };
  const toggleAccordionThemes = () => {
    setIsOpenThemes(!isOpenThemes);
  };

  const toggleAccordionDuration = () => {
    setIsOpenDuration(!isOpenDuration);
  };
  const handleCheckboxChange = () => { };
  // sam work start

  const [destinationArray, setDestinationArray] = useState([]);
  const [selectedBudget, setSelectedBudget] = useState("");
  const [durationArray, setDurationArray] = useState([]);
  const [minMax, setMinMax] = useState({
    min: "",
    max: "",
  });

  const handleBudgetChange = (value) => {
    setMinMax((prevMinMax) => ({
      min: "",
      max: "",
    }));
    setSelectedBudget(value);
  };

  const handleDurationCheckboxChange = (category) => {
    setNoOfNights("");
    setDurationArray((prevArray) => {
      if (prevArray.includes(category)) {
        return prevArray.filter((item) => item !== category);
      } else {
        return [...prevArray, category];
      }
    });
  };
  const handleDestinationHandleChange = (category) => {
    setDestinationArray((prevArray) => {
      if (prevArray.includes(category)) {
        return prevArray.filter((item) => item !== category);
      } else {
        return [...prevArray, category];
      }
    });
  };
  const handleThemesHandleChange = (category) => {
    setSelectedThemesArray((prevArray) => {
      if (prevArray.includes(category)) {
        return prevArray.filter((item) => item !== category);
      } else {
        return [...prevArray, category];
      }
    });
  };

  // console.log(destinationArray, "destinationArray");

  useEffect(() => {
    const data = {
      budget: selectedBudget,
      duration: durationArray,
      destinations: destinationArray,
      noOfNights: noOfNights,
      themes: selectedThemesArray,
    };

    sendDataToParent(data);
  }, [
    selectedBudget,
    durationArray,
    destinationArray,
    noOfNights,
    selectedThemesArray,
  ]);

  const handleBudgetChangeMinMax = (value) => {
    // console.log(value, "value");
    const { min, max } = value;
    if (Number(min) > Number(max)) {
      showErrorToast("Please Enter Valid Budget Range");
      return;
    }
    setSelectedBudget(`${min}-${max}`);
  };

  const onValuesChange = (data) => {
    setDurationArray([]);
    setNoOfNights(data);
  };

  const [modifyPkg, setModiyPkg] = useState(false);
  const [mobileHead, setMobileHead] = useState(false);
  const toggleModify = () => {
    setModiyPkg(!modifyPkg);
  };

  const closePopup = () => {
    setModiyPkg(false);
  };

  useEffect(() => {
    if (window.innerWidth <= 768) {
      setMobileHead(true);
    } else {
      setMobileHead(false);
    }
  }, []);

  const sendingData = {
    budget: selectedBudget,
    duration: durationArray,
    destinations: destinationArray,
    noOfNights: noOfNights,
  };

  return (
    <>
      {mobileHead ? (
        <>
          <div className="flex w-full flex_gap_10 align_items_center mobile_filter">
            <button onClick={toggleModify}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <mask
                  id="mask0_4297_3915"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="24"
                  height="24"
                >
                  <rect width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_4297_3915)">
                  <path
                    d="M12 21C11.7167 21 11.4792 20.9042 11.2875 20.7125C11.0958 20.5208 11 20.2833 11 20V16C11 15.7167 11.0958 15.4792 11.2875 15.2875C11.4792 15.0958 11.7167 15 12 15C12.2833 15 12.5208 15.0958 12.7125 15.2875C12.9042 15.4792 13 15.7167 13 16V17H20C20.2833 17 20.5208 17.0958 20.7125 17.2875C20.9042 17.4792 21 17.7167 21 18C21 18.2833 20.9042 18.5208 20.7125 18.7125C20.5208 18.9042 20.2833 19 20 19H13V20C13 20.2833 12.9042 20.5208 12.7125 20.7125C12.5208 20.9042 12.2833 21 12 21ZM4 19C3.71667 19 3.47917 18.9042 3.2875 18.7125C3.09583 18.5208 3 18.2833 3 18C3 17.7167 3.09583 17.4792 3.2875 17.2875C3.47917 17.0958 3.71667 17 4 17H8C8.28333 17 8.52083 17.0958 8.7125 17.2875C8.90417 17.4792 9 17.7167 9 18C9 18.2833 8.90417 18.5208 8.7125 18.7125C8.52083 18.9042 8.28333 19 8 19H4ZM8 15C7.71667 15 7.47917 14.9042 7.2875 14.7125C7.09583 14.5208 7 14.2833 7 14V13H4C3.71667 13 3.47917 12.9042 3.2875 12.7125C3.09583 12.5208 3 12.2833 3 12C3 11.7167 3.09583 11.4792 3.2875 11.2875C3.47917 11.0958 3.71667 11 4 11H7V10C7 9.71667 7.09583 9.47917 7.2875 9.2875C7.47917 9.09583 7.71667 9 8 9C8.28333 9 8.52083 9.09583 8.7125 9.2875C8.90417 9.47917 9 9.71667 9 10V14C9 14.2833 8.90417 14.5208 8.7125 14.7125C8.52083 14.9042 8.28333 15 8 15ZM12 13C11.7167 13 11.4792 12.9042 11.2875 12.7125C11.0958 12.5208 11 12.2833 11 12C11 11.7167 11.0958 11.4792 11.2875 11.2875C11.4792 11.0958 11.7167 11 12 11H20C20.2833 11 20.5208 11.0958 20.7125 11.2875C20.9042 11.4792 21 11.7167 21 12C21 12.2833 20.9042 12.5208 20.7125 12.7125C20.5208 12.9042 20.2833 13 20 13H12ZM16 9C15.7167 9 15.4792 8.90417 15.2875 8.7125C15.0958 8.52083 15 8.28333 15 8V4C15 3.71667 15.0958 3.47917 15.2875 3.2875C15.4792 3.09583 15.7167 3 16 3C16.2833 3 16.5208 3.09583 16.7125 3.2875C16.9042 3.47917 17 3.71667 17 4V5H20C20.2833 5 20.5208 5.09583 20.7125 5.2875C20.9042 5.47917 21 5.71667 21 6C21 6.28333 20.9042 6.52083 20.7125 6.7125C20.5208 6.90417 20.2833 7 20 7H17V8C17 8.28333 16.9042 8.52083 16.7125 8.7125C16.5208 8.90417 16.2833 9 16 9ZM4 7C3.71667 7 3.47917 6.90417 3.2875 6.7125C3.09583 6.52083 3 6.28333 3 6C3 5.71667 3.09583 5.47917 3.2875 5.2875C3.47917 5.09583 3.71667 5 4 5H12C12.2833 5 12.5208 5.09583 12.7125 5.2875C12.9042 5.47917 13 5.71667 13 6C13 6.28333 12.9042 6.52083 12.7125 6.7125C12.5208 6.90417 12.2833 7 12 7H4Z"
                    fill="#1C1B1F"
                  />
                </g>
              </svg>
            </button>
            <button className="filter_btn" onClick={toggleModify}>
              Budget
            </button>
            <button className="filter_btn" onClick={toggleModify}>
              Star Rating
            </button>
          </div>
          {modifyPkg && (
            <div className="filters p_0" id="mobileFilters">
              <div className="p_20">
                <svg
                  onClick={closePopup}
                  width="14"
                  height="13"
                  viewBox="0 0 14 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M1 12.5L13 0.5" stroke="#AAAAAA" strokeWidth="1.2" />
                  <path d="M13 12.5L1 0.5" stroke="#AAAAAA" strokeWidth="1.2" />
                </svg>
              </div>
              <div className="agent border-bottom-one">
                <h4>Filter</h4>
                <div className="buttons m_0">
                  <button
                    className="primary_btn"
                    onClick={handleReset}
                    style={{ width: "50px" }}
                  >
                    Reset
                  </button>
                </div>
              </div>
              <div className="filter_checkbox border-bottom-one">
                <h6
                  className="flex_align_center justify_content_between"
                  onClick={toggleAccordionBudget}
                  style={{ cursor: "pointer" }}
                >
                  <b>
                    Budget <small>(Rate/Night)</small>
                  </b>
                  <svg
                    width="10"
                    height="8"
                    viewBox="0 0 13 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      transition: "transform 0.5s",
                      transform: isOpenBudget
                        ? "rotate(0deg)"
                        : "rotate(180deg)",
                    }}
                  >
                    <path
                      d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                      stroke="#222222"
                      strokeWidth="1.5"
                    />
                  </svg>
                </h6>
                {isOpenBudget && (
                  <div>
                    <div className="flex pt_10">
                      <input
                        type="radio"
                        checked={"0-500" === selectedBudget}
                        value={"0-500"}
                        onChange={(e) => handleBudgetChange(e.target.value)}
                        id="0-500"
                      />
                      <label htmlFor="0-500">0 to ₹500</label>
                    </div>
                    <div className="flex pt_10">
                      <input
                        type="radio"
                        value={"500-1500"}
                        checked={"500-1500" === selectedBudget}
                        onChange={(e) => handleBudgetChange(e.target.value)}
                        id="500-1500"
                      />
                      <label htmlFor="500-1500">₹500 to ₹1500</label>
                    </div>
                    <div className="flex pt_10">
                      <input
                        type="radio"
                        value={"1500-3000"}
                        checked={"1500-3000" === selectedBudget}
                        onChange={(e) => handleBudgetChange(e.target.value)}
                        id="1500-3000"
                      />
                      <label htmlFor="1500-3000">₹1500 to ₹3000</label>
                    </div>
                    <div className="flex pt_10">
                      <input
                        type="radio"
                        value={"3000-5000"}
                        checked={"3000-5000" === selectedBudget}
                        onChange={(e) => handleBudgetChange(e.target.value)}
                        id="3000-5000"
                      />
                      <label htmlFor="3000-5000">₹3000 to 5000</label>
                    </div>
                    <div className="flex pt_10">
                      <input
                        type="radio"
                        value={"5000-15000"}
                        checked={"5000-15000" === selectedBudget}
                        onChange={(e) => handleBudgetChange(e.target.value)}
                        id="5000-15000"
                      />
                      <label htmlFor="5000-15000">₹5000 to 15000</label>
                    </div>
                    {/* <div>
                      <strong style={{ marginTop: "10px", display: "block" }}>
                        Your Budget
                      </strong>
                      <div className="filter_your_budget_parent">
                        <span className="filter_your_budget">
                          <input
                            // disabled={selectedBudget ? true : false}
                            type="number"
                            placeholder="Min"
                            id="min"
                            name="min"
                            value={minMax.min}
                            onChange={(e) => {
                              setSelectedBudget("");
                              setMinMax({ ...minMax, min: e.target.value });
                            }}
                          />
                        </span>
                        <span>to</span>

                        <span className="filter_your_budget">
                          <input
                            // disabled={selectedBudget ? true : false}
                            type="number"
                            placeholder="Max"
                            id="max"
                            name="max"
                            value={minMax.max}
                            onChange={(e) => {
                              setSelectedBudget("");
                              setMinMax({ ...minMax, max: e.target.value });
                            }}
                          />
                        </span>

                        <button
                          onClick={() => handleBudgetChangeMinMax(minMax)}
                          className="icon_btn"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="#fff"
                          >
                            <path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z" />
                          </svg>
                        </button>
                      </div>
                      
                    </div> */}
                  </div>
                )}
              </div>

              <div className="apply_btn">
                <button
                  onClick={() => {
                    sendDataToParent(sendingData);
                    setModiyPkg(false);
                  }}
                  className="primary_btn"
                >
                  <h4>Apply Now</h4>
                </button>
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="filters">
          <div className="agent border-bottom-one">
            <h4>Filter</h4>
            <div className="buttons m_0">
              <button
                className="primary_btn"
                onClick={handleReset}
                style={{ width: "50px" }}
              >
                Reset
              </button>
            </div>
          </div>

          <div className="filter_checkbox">
            <h6
              className="flex_align_center justify_content_between"
              onClick={toggleAccordionBudget}
              style={{ cursor: "pointer" }}
            >
              <b>
                Budget <small>(Rate/Night)</small>
              </b>
              <svg
                width="10"
                height="8"
                viewBox="0 0 13 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  transition: "transform 0.5s",
                  transform: isOpenBudget ? "rotate(0deg)" : "rotate(180deg)",
                }}
              >
                <path
                  d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                  stroke="#222222"
                  strokeWidth="1.5"
                />
              </svg>
            </h6>
            {isOpenBudget && (
              <div>
                <div className="flex pt_10">
                  <input
                    type="radio"
                    checked={"0-500" === selectedBudget}
                    value={"0-500"}
                    onChange={(e) => handleBudgetChange(e.target.value)}
                    id="0-500"
                  />
                  <label htmlFor="0-500">0 to ₹500</label>
                </div>
                <div className="flex pt_10">
                  <input
                    type="radio"
                    value={"500-1500"}
                    checked={"500-1500" === selectedBudget}
                    onChange={(e) => handleBudgetChange(e.target.value)}
                    id="500-1500"
                  />
                  <label htmlFor="500-1500">₹500 to ₹1500</label>
                </div>
                <div className="flex pt_10">
                  <input
                    type="radio"
                    value={"1500-3000"}
                    checked={"1500-3000" === selectedBudget}
                    onChange={(e) => handleBudgetChange(e.target.value)}
                    id="1500-3000"
                  />
                  <label htmlFor="1500-3000">₹1500 to ₹3000</label>
                </div>
                <div className="flex pt_10">
                  <input
                    type="radio"
                    value={"3000-5000"}
                    checked={"3000-5000" === selectedBudget}
                    onChange={(e) => handleBudgetChange(e.target.value)}
                    id="3000-5000"
                  />
                  <label htmlFor="3000-5000">₹3000 to 5000</label>
                </div>
                <div className="flex pt_10">
                  <input
                    type="radio"
                    value={"5000-15000"}
                    checked={"5000-15000" === selectedBudget}
                    onChange={(e) => handleBudgetChange(e.target.value)}
                    id="5000-15000"
                  />
                  <label htmlFor="5000-15000">₹5000 to 15000</label>
                </div>
                {/* <div>
                 <strong style={{ marginTop: "10px", display: "block" }}>
                   Your Budget
                 </strong>
                 <div className="filter_your_budget_parent">
                   <span className="filter_your_budget">
                     <input
                       // disabled={selectedBudget ? true : false}
                       type="number"
                       placeholder="Min"
                       id="min"
                       name="min"
                       value={minMax.min}
                       onChange={(e) => {
                         setSelectedBudget("");
                         setMinMax({ ...minMax, min: e.target.value });
                       }}
                     />
                   </span>
                   <span>to</span>

                   <span className="filter_your_budget">
                     <input
                       // disabled={selectedBudget ? true : false}
                       type="number"
                       placeholder="Max"
                       id="max"
                       name="max"
                       value={minMax.max}
                       onChange={(e) => {
                         setSelectedBudget("");
                         setMinMax({ ...minMax, max: e.target.value });
                       }}
                     />
                   </span>

                   <button
                     onClick={() => handleBudgetChangeMinMax(minMax)}
                     className="icon_btn"
                   >
                     <svg
                       xmlns="http://www.w3.org/2000/svg"
                       width="24"
                       height="24"
                       fill="#fff"
                     >
                       <path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z" />
                     </svg>
                   </button>
                 </div>
                 
               </div> */}
              </div>
            )}
          </div>



          {/* )} */}
        </div>
      )}
    </>
  );
}
export default FilterActivities;
